import React, { useState } from 'react'
import winicon from '../icons/favicon.png'
import searchico from '../icons/search.svg'
import edgeico from '../icons/edgeicon.png'
import chromeico from '../icons/chrome.png'
import vscode from '../icons/vscode.png'
import fileexpico from '../icons/fileExplorer.png'
import battery from '../icons/batteryFull.svg'
import wifi from '../icons/wifi.svg'
import speaker from '../icons/speaker.svg'
import msstore from '../icons/Microsoft_Store_app_icon.png'

const Taskbar = ({ toggleSideNav, toggleStartMenu, toggleCalenderHandle, toggleIconTray, closeWindow }) => {
    const [currentTime, setCurrentTime] = useState(new Date().toLocaleTimeString())
    const [currentDate, setCurrentDate] = useState(new Date().toLocaleDateString())

    // let date = new Date().toLocaleDateString()
    
    const updateTimeAnddate = ()=>{
        let time = new Date().toLocaleTimeString()
        setCurrentTime(time)
    }

    setInterval(updateTimeAnddate, 1000)

    return (
        <div className='mainContainer flex justify-center items-center py-1 bg-white w-[100vw] relative bg-opacity-90'>

            <div className="middle_icons flex space-x-3">
                <span onClick={toggleStartMenu} className='hover:bg-gray-300 rounded-md transition delay-[50ms] p-1'><img className='h-7 w-auto' src={winicon} alt="nav-logo" /></span>
                <span className='hover:bg-gray-300 rounded-md transition delay-[50ms] p-1'><img className='h-7 w-auto' src={searchico} alt="nav-logo" /></span>
                <span onClick={closeWindow} className='hover:bg-gray-300 rounded-md transition delay-[50ms] p-1'><img className='h-7 w-auto' src={fileexpico} alt="nav-logo" /></span>
                <span className='hover:bg-gray-300 rounded-md transition delay-[50ms] p-1'><img className='h-7 w-auto' src={edgeico} alt="nav-logo" /></span>
                <span className='hover:bg-gray-300 rounded-md transition delay-[50ms] p-1'><img className='h-7 w-auto' src={chromeico} alt="nav-logo" /></span>
                <span className='hover:bg-gray-300 rounded-md transition delay-[50ms] p-1'><img className='h-7 w-auto' src={vscode} alt="nav-logo" /></span>
                <span className='hover:bg-gray-300 rounded-md transition delay-[50ms] p-1'><img className='h-7 w-auto' src={msstore} alt="nav-logo" /></span>
            </div>

            {/* right container */}
            <div className="right_icons flex space-x-1 items-center absolute right-0 mr-1">
                <div onClick={toggleIconTray} className='hover:bg-gray-200 rounded-md px-1 py-[6px]'>
                    <i className="fa-solid fa-angle-up"></i>
                </div>

                <div onClick={toggleSideNav} className="icons flex space-x-2 hover:bg-gray-200 rounded-md transition delay-[50ms] p-1">
                    <span><img className='h-7 w-auto' src={battery} alt="icons" /></span>
                    <span><img className='h-7 w-auto' src={wifi} alt="icons" /></span>
                    <span><img className='h-7 w-auto' src={speaker} alt="icons" /></span>
                </div>

                <div onClick={toggleCalenderHandle} className="clock_container flex flex-col text-xs hover:bg-gray-200 rounded-md transition delay-[50ms] px-2 py-[2px] cursor-default">
                    {/* <span>{currentHour < 10 ? 0 : ""}{(currentHour > 12) ? currentHour - 12 : currentHour}:{currentMinutes} {currentHour > 12 ? "PM" : "AM"}</span>
                    <span>{currentDate < 10? 0: ""}{currentDate}-{currentMonth < 10? 0: ""}{currentMonth}-{currentYear}</span> */}
                    <span>{currentTime}</span>
                    <span>{currentDate}</span>
                </div>
            </div>

        </div>

    )
}

export default Taskbar
